(() => {
  'use strict';
  const guide = document.querySelector('[data-finiks-intelligence]');
  const cameraButton = document.querySelector('[data-finiks-camera]');
  const voiceButton = document.querySelector('[data-finiks-voice]');
  if (!guide || !cameraButton || !voiceButton) return;
  const messages = guide.querySelector('[data-finiks-messages]');
  const addNotice = text => {
    const message = document.createElement('div');
    message.className = 'fg-intelligence__message';
    message.textContent = text;
    messages.appendChild(message);
    messages.scrollTo({ top: messages.scrollHeight, behavior: 'smooth' });
  };
  const make = (tag, text, className) => {
    const element = document.createElement(tag);
    if (text) element.textContent = text;
    if (className) element.className = className;
    return element;
  };
  const openDialog = (title, description) => {
    const dialog = document.createElement('dialog');
    dialog.className = 'fg-media-dialog';
    const header = make('header');
    header.append(make('h2', title));
    const close = make('button', 'Close');
    close.type = 'button';
    close.addEventListener('click', () => dialog.close());
    header.append(close);
    const body = make('div', '', 'fg-media-dialog__body');
    body.append(make('p', description));
    dialog.append(header, body);
    document.body.append(dialog);
    dialog.addEventListener('close', () => dialog.remove());
    dialog.showModal();
    return { dialog, body };
  };
  const dispatchSearch = (query, source) => document.dispatchEvent(new CustomEvent('finiks:assistant-search', { detail: { query: String(query || '').slice(0, 80), source } }));
  const cameraFeature = () => {
    const { dialog, body } = openDialog('Camera search', 'Use the camera to scan a barcode or QR code. Your browser asks for permission only after you select Start camera.');
    const video = document.createElement('video');
    video.autoplay = true;
    video.muted = true;
    video.playsInline = true;
    video.className = 'fg-media-dialog__video';
    const status = make('p', 'Camera is off.', 'fg-media-dialog__status');
    const actions = make('div', '', 'fg-media-dialog__actions');
    const start = make('button', 'Start camera');
    const stop = make('button', 'Stop camera');
    [start, stop].forEach(button => { button.type = 'button'; actions.append(button); });
    stop.disabled = true;
    body.append(video, status, actions);
    let stream;
    let scanner;
    let detector;
    const stopCamera = () => {
      if (scanner) window.clearInterval(scanner);
      scanner = undefined;
      stream?.getTracks?.().forEach(track => track.stop());
      stream = undefined;
      video.srcObject = null;
      start.disabled = false;
      stop.disabled = true;
      status.textContent = 'Camera is off.';
    };
    const scan = async () => {
      if (!detector || video.readyState < HTMLMediaElement.HAVE_CURRENT_DATA) return;
      try {
        const matches = await detector.detect(video);
        const value = matches[0]?.rawValue;
        if (!value) return;
        status.textContent = `Barcode or QR code found: ${value}. Searching the live catalogue.`;
        window.FiniksIntent?.record('visual_search');
        dispatchSearch(value, 'camera');
        stopCamera();
      } catch {}
    };
    start.addEventListener('click', async () => {
      if (!navigator.mediaDevices?.getUserMedia) { status.textContent = 'This browser does not support camera access.'; return; }
      try {
        stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: false });
        video.srcObject = stream;
        await video.play();
        try { detector = new BarcodeDetector({ formats: ['qr_code', 'ean_13', 'ean_8', 'code_128', 'upc_a', 'upc_e'] }); } catch { try { detector = new BarcodeDetector(); } catch { detector = undefined; } }
        if (detector) scanner = window.setInterval(scan, 800);
        status.textContent = detector ? 'Camera active. Point it at a barcode or QR code.' : 'Camera active. Barcode recognition is not available in this browser.';
        start.disabled = true;
        stop.disabled = false;
      } catch {
        status.textContent = 'Camera access was not granted or is unavailable.';
      }
    });
    stop.addEventListener('click', stopCamera);
    dialog.addEventListener('close', stopCamera, { once: true });
  };
  const voiceFeature = () => {
    const { dialog, body } = openDialog('Voice product search', 'Speak a product or store question. Your browser asks for microphone permission only after you select Start listening.');
    const status = make('p', 'Microphone is off.', 'fg-media-dialog__status');
    const actions = make('div', '', 'fg-media-dialog__actions');
    const start = make('button', 'Start listening');
    const stop = make('button', 'Stop listening');
    start.type = 'button';
    stop.type = 'button';
    stop.disabled = true;
    actions.append(start, stop);
    body.append(status, actions);
    const Recognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    let recognition;
    const stopListening = () => {
      recognition?.stop();
      recognition = undefined;
      start.disabled = false;
      stop.disabled = true;
    };
    start.addEventListener('click', async () => {
      if (!Recognition || !navigator.mediaDevices?.getUserMedia) { status.textContent = 'Voice search is not available in this browser.'; return; }
      try {
        const permissionStream = await navigator.mediaDevices.getUserMedia({ audio: true, video: false });
        permissionStream.getTracks().forEach(track => track.stop());
        recognition = new Recognition();
        recognition.lang = document.documentElement.lang || 'en';
        recognition.interimResults = false;
        recognition.maxAlternatives = 1;
        recognition.onstart = () => { status.textContent = 'Listening. Use Stop listening to end now.'; };
        recognition.onresult = event => {
          const transcript = String(event.results[0]?.[0]?.transcript || '').trim();
          if (!transcript) return;
          status.textContent = `Searching the live catalogue for: ${transcript}`;
          window.FiniksIntent?.record('voice_search');
          dispatchSearch(transcript, 'voice');
        };
        recognition.onerror = () => { status.textContent = 'Voice search could not understand a request. You can use text search instead.'; };
        recognition.onend = () => { start.disabled = false; stop.disabled = true; };
        start.disabled = true;
        stop.disabled = false;
        recognition.start();
      } catch {
        status.textContent = 'Microphone access was not granted or is unavailable.';
        stopListening();
      }
    });
    stop.addEventListener('click', () => { status.textContent = 'Microphone is off.'; stopListening(); });
    dialog.addEventListener('close', stopListening, { once: true });
  };
  cameraButton.addEventListener('click', cameraFeature);
  voiceButton.addEventListener('click', voiceFeature);
})();
